import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { IATQuickFilter, IATTableColConfig } from 'types/ActionTrackerGraphs'

interface props {
  columns: IATTableColConfig[]
  quickFilter: IATQuickFilter
  globalFilters: IATQuickFilter
}

const initialState: props = {
  columns: [] as IATTableColConfig[],
  quickFilter: {} as IATQuickFilter,
  globalFilters: {} as IATQuickFilter,
}

const modalStateSlice = createSlice({
  name: 'ActionTrackerTableConfig',
  initialState,
  reducers: {
    setATTableConfig: (state, action: PayloadAction<Omit<props, 'columns'>>) => {
      Object.assign(state, action.payload)
    },
    clearATTTableConfig: (state) => {
      Object.assign(state, initialState)
    },
    UpdateATTableColumnOrder: (state, action) => {
      let { columnOrder, columnDefaultNames} = action.payload
      const result = state.columns?.reduce((acc: any, item) => {
        acc[item.key] = item
        return acc
      }, {})

      if (columnOrder.findIndex((column: string) => column === 'mrt-row-actions') !== -1) {
        columnOrder = columnOrder?.filter((item: string) => item !== 'mrt-row-actions')
      }

      const columns = columnOrder?.map((column: string) => {
        return {
          key: column,
          name: result[column]?.name ?? (columnDefaultNames[column] ?? column),
          is_visible: result[column]?.is_visible,
        }
      })
      state.columns = columns
    },

    UpdateATTableColumnVisible: (state, action) => {
      const { columnVisible } = action.payload
      const columns = state.columns?.map((column) => ({
        ...column,
        is_visible: columnVisible[column?.key] ?? false,
      }))
      state.columns = columns
    },

    UpdateATGlobalFilter: (state, action) => {
      const { globalFilter } = action.payload
      
      state.globalFilters = globalFilter
    },

    ChangeATQuickFilter: (state, action) => {
      const { quickFilter } = action.payload
      state.quickFilter = quickFilter
    },
    UpdateATQuickFilter:(state, action)=>{
      state.quickFilter = {...state.quickFilter, ...action.payload}
    },
  },
})

export const {
  setATTableConfig,
  UpdateATTableColumnOrder,
  UpdateATTableColumnVisible,
  UpdateATGlobalFilter,
  ChangeATQuickFilter,
  clearATTTableConfig,
  UpdateATQuickFilter
} = modalStateSlice.actions
export default modalStateSlice.reducer
